import type { FC } from "react";
import styles from "../agentChatDrawer.module.scss";
import IconButton from "@mui/material/IconButton";
import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { useTranslation } from "react-i18next";

type AgentHeaderProps = {
  showClearButton: boolean;
  handleClose: () => void;
  handleClear: () => void;
}

const AgentHeader: FC<AgentHeaderProps> = ({showClearButton, handleClear, handleClose}) => {
  const { t } = useTranslation("translation", { keyPrefix: "agentChat" });

  return (
    <div className={styles.header}>
      <div className={styles.title}>{t("title")}</div>
      <div className={styles.headerActions}>
        {showClearButton ? (
          <IconButton className={styles.clearButton} onClick={handleClear}>
            {t("clear")}
          </IconButton>
        ) : null}
        <IconButton className={styles.closeButton} onClick={handleClose} aria-label={t("close")}>
          <XIcon size={18} />
        </IconButton>
      </div>
    </div>
  );
};

export default AgentHeader;
